import { render, staticRenderFns } from "./SalesOverviewTable.vue?vue&type=template&id=0adbe261"
import script from "./SalesOverviewTable.vue?vue&type=script&lang=ts"
export * from "./SalesOverviewTable.vue?vue&type=script&lang=ts"
import style0 from "./SalesOverviewTable.vue?vue&type=style&index=0&id=0adbe261&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports